import React, { Fragment, useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Moment from "react-moment";
import { Link } from "react-router-dom";

import ToggleButton from "../../PlayerButtons/ToggleButton";

const VRTourMiniVideo = ({ vrtour }) => {
  const videoRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [showOverlay, setshowOverlay] = useState(true);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateDuration = () => {
      setDuration(video.duration);
    };
    video.addEventListener("loadedmetadata", updateDuration);

    return () => video.removeEventListener("loadedmetadata", updateDuration);
  }, [setDuration]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateTime = () => {
      setCurrentTime(video.currentTime);
    };
    video.addEventListener("timeupdate", updateTime);
    return () => video.removeEventListener("timeupdate", updateTime);
  }, [currentTime, setCurrentTime]);

  return (
    <Fragment>
      {vrtour.tours &&
        vrtour.tours.map((tour) => {
          return (
            <div key={tour._id}>
              <div className="content-container">
                <div className="stream-result">
                  <div className="stream-video">
                    <div
                      className={
                        showOverlay ? "video-overlay" : "video-overlay-alt"
                      }
                    >
                      <div className="stream-live blue">
                        <i className="fas fa-street-view fa-2x mx-5"></i>
                      </div>
                      <ToggleButton
                        className="alt-center-controls"
                        value={() =>
                          videoRef.current && !videoRef.current.paused
                        }
                        onChange={(active) => {
                          if (!active) {
                            return videoRef.current.pause();
                          }

                          return videoRef.current.play();
                        }}
                      >
                        {(active) => {
                          if (
                            currentTime > 0.1 &&
                            currentTime < duration &&
                            active
                          ) {
                            setshowOverlay(true);
                            return (
                              <i
                                className="far fa-pause-circle blue fa-3x"
                                onClick={() => videoRef.current.pause()}
                              ></i>
                            );
                          } else {
                            setshowOverlay(false);
                          }
                          if (currentTime === duration) {
                            setCurrentTime(0);
                          } else if (currentTime === 0 && !active) {
                            return (
                              <i
                                className="far fa-play-circle blue fa-3x"
                                onClick={() => videoRef.current.play()}
                              ></i>
                            );
                          }
                          return (
                            <i
                              className="far fa-play-circle blue fa-3x"
                              onClick={() => videoRef.current.play()}
                            ></i>
                          );
                        }}
                      </ToggleButton>
                      <div className="stream-viewers white">
                        <i className="fas fa-user mx-5"></i>
                        {tour.views.length}
                      </div>
                    </div>
                    <video
                      className="stream-media"
                      ref={videoRef}
                      src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/vr_tour_videos/${tour.tourvideo}`}
                      poster={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/vr_tour_images/${tour.tourimage}`}
                    ></video>
                  </div>
                  <div className="stream-info-container">
                    <div className="result-avi-container">
                      <img
                        src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${tour.avatar}`}
                        className="result-avi"
                      />
                    </div>
                    <div className="stream-info-items">
                      <p className="result-stream-description">
                        {tour.tourtitle}
                      </p>
                      <ul className="result-stream-items">
                        <li className="stream-item blue bold">
                          {tour.companyname}
                        </li>
                        <li className="stream-item">
                          {tour.firstname} {tour.lastname}
                        </li>
                        <li className="stream-item">
                          {tour.location.city}, {tour.location.state}
                        </li>
                        <li className="stream-item">
                          <i className="far fa-clock mr-5 blue"></i>
                          <Moment format="MM/DD/YYYY">{tour.date}</Moment>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <Link to={`/vrtours/${tour.channelid}/${tour._id}`}>
                  <div className="result-button-container">
                    <button className="result-button background-dark-black white">
                      Watch<i className="far fa-play-circle blue mx-5"></i>
                    </button>
                  </div>
                </Link>
              </div>
            </div>
          );
        })}
    </Fragment>
  );
};

VRTourMiniVideo.propTypes = {
  vrtour: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  vrtour: state.vrtour,
});

export default connect(mapStateToProps)(VRTourMiniVideo);
